import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'

import { ROLES } from '@/shared/auth/constants'
import { roleAuthGuard } from '@/shared/auth/utils/router'

export const Route = createFileRoute('/_dashboard/settings/tenant-settings')({
	beforeLoad: ({ location }) => {
		roleAuthGuard(ROLES.Admin)

		if (location.pathname === '/settings/tenant-settings') {
			throw redirect({
				to: '/settings/tenant-settings/members',
			})
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Tenant Settings | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return <Outlet />
}
